const POC_VALID_FLOW_BASE = 'login/isPOCRedirectValid';
export default Object.freeze({
    POC_VALID_FLOW: POC_VALID_FLOW_BASE,
    POC_VALID_FLOW_PENDING: `${POC_VALID_FLOW_BASE}/pending`,
    POC_VALID_FLOW_FULFILLED: `${POC_VALID_FLOW_BASE}/fulfilled`,
    POC_VALID_FLOW_REJECTED: `${POC_VALID_FLOW_BASE}/rejected`,
});
